import topBookedLegsFilteredDeduped from '~/components/Playground/top-booked-legs-filtered.json';

const INCLUDED_PLACES = [
  'Aachen',
  'Aberdeen',
  'Aix-en-Provence',
  'Alassio',
  'Amiens',
  'Amsterdam',
  'Andermatt',
  'Antwerp',
  'Apeldoorn',
  'Appenzell',
  'Arnhem',
  'Arosa',
  'Avignon',
  'Baden-Baden',
  'Barcelona',
  'Basel',
  'Bath',
  'Bellano',
  'Bergen',
  'Berlin',
  'Bern',
  'Betws-y-Coed',
  'Beziers',
  'Bilbao',
  'Bologna',
  'Bordeaux',
  'Bremen',
  'Brig',
  'Bruges',
  'Brussels',
  'Budapest',
  'Burgos',
  'Carcassonne',
  'Cassis',
  'Catania',
  'Chambery',
  'Chur',
  'Collioure',
  'Colmar',
  'Copenhagen',
  'Corfe Castle',
  'Cuneo',
  'Cádiz',
  'Córdoba',
  'Delft',
  'Desenzano del Garda',
  'Dijon',
  'Domodossola',
  'Dresden',
  'Dublin',
  'Duisburg',
  'Dundee',
  'Dusseldorf',
  'Edinburgh',
  'Falmouth',
  'Fes',
  'Fez',
  'Figueres',
  'Florence',
  'Fort William',
  'Frankfurt',
  'Freiburg',
  'Geneva',
  'Genoa',
  'Ghent',
  'Girona',
  'Glasgow',
  'Glenfinnan',
  'Gothenburg',
  'Gouda',
  'Granada',
  'Grandvaux',
  'Graz',
  'Grindelwald',
  'Groningen',
  'Haarlem',
  'Hamburg',
  'Hanover',
  'Heidelberg',
  'Hendaye',
  'Holyhead',
  'Interlaken',
  'Inverness',
  'Karlsruhe',
  'Koblenz',
  'Konstanz',
  'Kortrijk',
  'Krakow',
  'Lausanne',
  'Lecco',
  'Leiden',
  'Leipzig',
  'Leuven',
  'León',
  'Lille',
  'Linz',
  'Lisbon',
  'Lisboa',
  'Liège',
  'Ljubljana',
  'Locarno',
  'London',
  'Lucerne',
  'Lugano',
  'Luxembourg City',
  'Lyon',
  'Maastricht',
  'Madrid',
  'Mainz',
  'Málaga',
  'Mallaig',
  'Marrakech',
  'Marrakesh',
  'Marseille',
  'Martigny',
  'Menton',
  'Metz',
  'Middelburg',
  'Milan',
  'Milano',
  'Mittenwald',
  'Montpellier',
  'Montreux',
  'Munich',
  'Naples',
  'Narbonne',
  'Nice',
  'Nîmes',
  'Nimes',
  'Nürnberg',
  'Oban',
  'Oslo',
  'Osnabrück',
  'Palermo',
  'Paris',
  'Penzance',
  'Perpignan',
  'Pitlochry',
  'Porto',
  'Portree',
  'Poschiavo',
  'Prague',
  'Riquewihr',
  'Rome',
  'Rotterdam',
  'Saarbrücken',
  'Salamanca',
  'Salzburg',
  'San Sebastián',
  'Santander',
  'Santiago de Compostela',
  'Segovia',
  'Seville',
  'Siena',
  'Sitges',
  'Sorrento',
  'Split',
  'St Ives',
  'St. Moritz',
  'Stockholm',
  'Strasbourg',
  'Stuttgart',
  'Swanage',
  'Syracuse',
  'Tangier',
  'Taormina',
  'Tarifa',
  'Tarragona',
  'Tende',
  'The Hague',
  'Den Haag',
  'Tirano',
  'Titisee',
  'Toulon',
  'Trier',
  'Trieste',
  'Turin',
  'Utrecht',
  'Valence',
  'Valencia',
  'València',
  'Vallorcine',
  'Varenna',
  'Venice',
  'Ventimiglia',
  'Verona',
  'Vienna',
  'Vigo',
  'Villach',
  'Warsaw',
  'Warszawa',
  'Wengen',
  'Winchester',
  'York',
  'Ypres',
  'Zagreb',
  'Zaragoza',
  'Zermatt',
  'Zürich'
];

type PopularLeg = {
  id: number;
  leg_count: number;
  percent: number;
  name: string;
  from_place: string;
  from_longitude: number;
  from_latitude: number;
  to_place: string;
  to_longitude: number;
  to_latitude: number;
};

const getPopularLegFeatures = (popularLegs: PopularLeg[]) => {
  return {
    type: 'FeatureCollection',
    features: popularLegs.map((leg) => ({
      type: 'Feature',
      properties: {
        id: leg.id,
        leg_count: leg.leg_count,
        percent: leg.percent
      },
      geometry: {
        type: 'LineString',
        coordinates: [
          [leg.from_longitude, leg.from_latitude],
          [leg.to_longitude, leg.to_latitude]
        ]
      }
    }))
  };
};

const filteredLegs = topBookedLegsFilteredDeduped.filter((leg) => {
  return INCLUDED_PLACES.includes(leg.from_place) && INCLUDED_PLACES.includes(leg.to_place);
});

export const popularLegs = getPopularLegFeatures(filteredLegs);

export const routeSource = {
  type: 'geojson',
  data: popularLegs
};

export const routeLayers = [
  {
    id: 'route-line-high',
    type: 'line',
    source: 'route-source',
    filter: ['>=', ['get', 'percent'], 2],
    layout: {
      'line-sort-key': ['-', 0, ['get', 'leg_count']]
    },
    paint: {
      'line-dasharray': [1, 0.5],
      'line-width': 2,
      'line-color': '#bbbbbb'
    }
  },
  {
    id: 'route-line-medium',
    type: 'line',
    source: 'route-source',
    filter: ['all', ['>=', ['get', 'percent'], 0.5], ['<', ['get', 'percent'], 2]],
    layout: {
      'line-sort-key': ['-', 0, ['get', 'leg_count']]
    },
    paint: {
      'line-dasharray': [2, 1],
      'line-width': 1,
      'line-color': '#bbbbbb'
    }
  },
  {
    id: 'route-line-low',
    type: 'line',
    source: 'route-source',
    filter: ['all', ['>=', ['get', 'percent'], 0], ['<', ['get', 'percent'], 0.5]],
    layout: {
      'line-sort-key': ['-', 0, ['get', 'leg_count']]
    },
    paint: {
      'line-dasharray': [2, 1],
      'line-width': 1,
      'line-color': '#bbbbbb'
    }
  }
];
